module.exports = "pegasus_template/assets/color-icon.png";